import React from 'react';
import { shouldComponentUpdate, ListChildComponentProps } from 'react-window';
import { Loader } from 'semantic-ui-react';

// @ts-ignore
import ErrorGate from 'components/ErrorGate';
import LoadingGate from 'components/LoadingGate';

import { VirtualizedItemData } from '../../types';
import VirtualizedTableRow from '../VirtualizedTableRow';
import VirtualizedTableEmptyRow from '../VirtualizedTableEmptyRow';
import VirtualizedTableContext from '../VirtualizedTableContext';

export interface Props extends ListChildComponentProps {
    data: VirtualizedItemData;
}

export class VirtualizedTableRowWrapperComponent extends React.Component<Props> {
    static contextType = VirtualizedTableContext;

    shouldComponentUpdate = shouldComponentUpdate.bind(this);

    render(): React.ReactElement | null {
        const { data, style, index } = this.props;
        const { loadNamespace } = this.context;
        const { getItemKey, isEmpty, labelPlural } = data;

        // Ignore first index to give space the sticky header
        if (!index) {
            return null;
        }

        if (isEmpty) {
            const emptyRow = (
                <VirtualizedTableEmptyRow
                    style={style}
                    labelPlural={labelPlural}
                />
            );

            if (loadNamespace) {
                return (
                    <LoadingGate
                        namespace={loadNamespace}
                        LoadingComponent={
                            <Loader
                                style={{ marginTop: '30px' }}
                                active
                                inline="centered"
                            />
                        }
                    >
                        <ErrorGate namespace={loadNamespace}>
                            {emptyRow}
                        </ErrorGate>
                    </LoadingGate>
                );
            }

            return emptyRow;
        }

        return <VirtualizedTableRow style={style} rowId={getItemKey(index)} />;
    }
}

export default VirtualizedTableRowWrapperComponent;
